import { FunctionComponent } from 'react'
import { WelcomeUserPvModalProps } from './WelcomeUserPvModal.types'
import { Center, Flex, getTheme, Modal, Text } from '@conexasaude/conexa-hero'
import { Positive } from '@conexasaude/iconography/illustrations'
import useStyles from './WelcomeUserPvModal.styles'
import ClariHelper from '@/components/Clari'
import { useAuthContext } from '../../contexts/AuthContext'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'

export const WelcomeUserPvModal: FunctionComponent<
  WelcomeUserPvModalProps
> = props => {
  const theme = getTheme()
  const style = useStyles()
  const { isClariEnabled } = useAuthContext()

  return (
    <Modal
      {...props}
      title="Boas-vindas à plataforma de pacientes Conexa!"
      iconTitle="information"
      primaryActionLabel="Entendi"
      primaryAction={props.onClose}
      size={700}
    >
      <Flex direction="column" py={theme.spacing.sm} gap={theme.spacing.sm}>
        <Center>
          <Positive height="240px" width="291px" />
        </Center>

        <Text variant="paragraphLarge">
          Os atendimentos que você realizava na Psicologia Viva agora acontecem
          aqui, com mais praticidade e em uma experiência aprimorada. Verifique
          as informações para acessar nossa nova plataforma:
        </Text>

        <ol css={style.list}>
          <li>
            Sua senha continua a mesma e login pode ser feito por CPF ou e-mail.
          </li>
          <li>Todos os dados e o histórico foram migrados.</li>
          <li>
            Temos novas ferramentas e melhorias para facilitar sua rotina.
          </li>
        </ol>

        <Text variant="paragraphLarge">
          O acesso pela Psicologia Viva foi descontinuado. Caso tenha problemas
          no seu acesso fale com nosso{' '}
          {isClariEnabled ? (
            <ClariHelper supportTextButton="suporte" />
          ) : (
            <Text variant="link" renderAs="span" onClick={openWhatsappSupport}>
              suporte
            </Text>
          )}
          .
          <br /> Vamos começar?
        </Text>
      </Flex>
    </Modal>
  )
}
